import Vue from 'vue';
import store from './../../store';
import accountService from "./index";

// When the request succeeds
const success = (data, context, lang, toastrShow) => {
    // accountService.find();
    if(toastrShow) {
      toastr.success(context.$t('account.settings.language_changed'));
    }
    Vue.config.lang = lang.lang;
    store.dispatch('changeLang', lang);
};

// When the request fails
const failed = (error, context) => {
    toastr.error(error);
};

export default (context, lang, toastrShow = true) => {
      return Vue.$http.post('/change-lang', lang).then((response) => {
      if (response && response.status === 200) {
        success(response.data, context, lang, toastrShow);
      }
    })
    .catch((error) => {
      failed(error,context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/changeLang.js